import React, { useEffect } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useTranslation } from "react-i18next";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Avatar from "@mui/material/Avatar";
import AccountConfirmed from "../../components/icons/AccountConfirmed";
import ConfirmationPending from "../../components/icons/ConfirmationPending";
import FormControlLabel from "@mui/material/FormControlLabel";
import IOSSwitch from "../../components/SwitchButton";
import DeleteIcon from "../../components/icons/DeleteIcon";

const UserDetails = ({ open, handleClose, selectedUser }) => {
  const isMobile = useMediaQuery("(max-width:900px)");
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="xl"
        PaperProps={{
          sx: !isMobile
            ? { width: "45%", padding: "20px", borderRadius: "20px" }
            : {
                width: "90%",
                height: "80%",
                margin: "5px 0",
                padding: "5px ",
                borderRadius: "20px",
              },
        }}
      >
        <Typography
          variant="subtitle3"
          sx={{ display: "flex", alignItems: "center", mb: 1 }}
        >
          <IconButton onClick={handleClose}>
            <KeyboardBackspaceIcon sx={{ width: "70%", color: "black" }} />
          </IconButton>
          {t("back")}
        </Typography>
        <DialogTitle>
          <div
            style={{
              display: isMobile ? "column" : "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Grid container alignItems="center">
              <Grid
                item
                xs={isMobile ? 12 : 2}
                align={isMobile ? "center" : "left"}
              >
                <Avatar
                  alt="Remy Sharp"
                  src="https://d34u5ed86vwark.cloudfront.net/MAN1.png"
                  sx={{
                    width: "80px",
                    height: "80px",
                  }}
                />
              </Grid>
              <Grid
                item
                xs={isMobile ? 12 : 10}
                align={isMobile ? "center" : "left"}
              >
                <Stack>
                  <Typography
                    variant="title8"
                    sx={{ fontSize: "20px" }}
                  >{`${selectedUser?.first_name} ${selectedUser?.last_name}`}</Typography>
                  <Typography variant="title9" sx={{ fontSize: "14px" }}>
                    {selectedUser?.email}
                  </Typography>
                </Stack>
              </Grid>
            </Grid>
            <div
              style={{
                marginTop: isMobile && "35px",
                display: isMobile && "flex",
                width: isMobile && "100%",
                justifyContent: isMobile && "center",
              }}
            >
              {" "}
              {selectedUser?.status ? (
                <div className="chip-confirmed">
                  <AccountConfirmed />
                  <Typography
                    variant="title9"
                    sx={{ fontSize: "14px" }}
                    color="#1DB954"
                  >
                    {t("user_confirmed")}
                  </Typography>
                </div>
              ) : (
                <div className="chip-pending">
                  <ConfirmationPending />
                  <Typography
                    variant="title9"
                    sx={{ fontSize: "14px" }}
                    color="#D9822F"
                  >
                    {t("user_pending")}
                  </Typography>
                </div>
              )}
            </div>
          </div>
        </DialogTitle>
        <DialogContent sx={{ marginTop: "20px" }}>
          {selectedUser?.role !== "enterprise_admin" &&
          selectedUser?.role !== "cytailor_admin" &&
            selectedUser?.role !== "enterprise_user" && (
              <>
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginTop: "20px",
                  }}
                >
                  <Typography variant="title9">{t("user_status")}</Typography>
                  <FormControlLabel
                    control={
                      <IOSSwitch
                        sx={{ margin: "8px -8px 4px 8px" }}
                        color='info'
                        defaultChecked
                      />
                    }
                  />
                </div>
                <Typography variant="subtitle4">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                </Typography>
              </>
            )}

          {selectedUser?.role !== "enterprise_admin" &&selectedUser?.role !== "cytailor_admin" && (
            <>
              <div style={{ marginTop: "24px" }}>
                <Typography variant="title9">{t("user_orga")}</Typography>
              </div>
              <div style={{ marginTop: "20px" }}>
                {selectedUser?.role === "enterprise_user" ? (
                  <div
                    style={{
                      display: "flex",
                      width: "100%",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: "15px",
                    }}
                  >
                    <Typography variant="subtitle7">
                      {selectedUser?.organization_name}
                    </Typography>
                  </div>
                ) : (
                  selectedUser?.managed_organizations?.map((el) => (
                    <div
                      style={{
                        display: "flex",
                        width: "100%",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "15px",
                      }}
                    >
                      <Typography variant="subtitle7">
                        {el?.orga_name}
                      </Typography>
                      <Button
                        variant="contained"
                        color="disabled"
                        size="small"
                        sx={{ height: "40px", minWidth: "40px" }}
                      >
                        <DeleteIcon />
                      </Button>
                    </div>
                  ))
                )}
              </div>
            </>
          )}
        </DialogContent>
        {/* <DialogActions>
          <Button autoFocus onClick={handleClose}>
            {t("close")}
          </Button>
        </DialogActions> */}
      </Dialog>
    </React.Fragment>
  );
};

export default UserDetails;
